import { getCookie } from "./helper-function";

export const parseUCASCookie = () => {
      try {
        const raw = getCookie('UCAS');
        if (!raw) return '';
        const decoded = decodeURIComponent(raw);
        const parsed = JSON.parse(decoded);
        return parsed?.ucasPoint || '';
      } catch (err) {
        console.error('Failed to decode UCAS cookie:', err);
        return '';
      }
    };
